export const Toast = {

    app: null,

    success: (data) =>
    {
        let form = {
            message: data.message,
            type: 'success',
            position: 'bottom-right',
            duration: 5000,
        };

        Toast.fire(form);
    },

    error: (data) =>
    {
        let form = {
            message: data.message,
            type: 'error',
            position: 'bottom-right',
            duration: 5000,
        };

        Toast.fire(form);
    },

    fire: (data) =>
    {
        Toast.app.$toast.show(
            data.message,
            {
                type: data.type,
                position: data.position,
                duration: data.duration,
            }
        );
    },

    register: (app) =>
    {
        Toast.app = app;
    }
};
